import React from "react";
import "./PaginationControls.css";
import ProductListButton from "../../Button/ProductListButton";

const PaginationControls = ({
  currentPage,
  productsPerPage,
  setProductsPerPage,
  setCurrentPage,
  filteredLength,
  totalEntries,
  paginate,
}) => {
  const totalPages = Math.ceil(filteredLength / productsPerPage);

  const renderPageNumbers = () => {
    const buttons = [];

    const showPage = (page) => (
      <button
        key={page}
        onClick={() => paginate(page)}
        className={`pagination-controls__page ${
          currentPage === page ? "pagination-controls__page--active" : ""
        }`}
      >
        {page}
      </button>
    );

    const total = totalPages;

    const range = new Set();

    // Always show first 3
    for (let i = 1; i <= Math.min(3, total); i++) range.add(i);

    // Always show last 3
    for (let i = Math.max(total - 2, 1); i <= total; i++) range.add(i);

    // Always show 2 pages before & after current
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      if (i > 0 && i <= total) range.add(i);
    }

    const sortedPages = [...range].sort((a, b) => a - b);

    let lastPage = 0;

    for (const page of sortedPages) {
      if (page - lastPage > 1) {
        buttons.push(
          <span
            key={`ellipsis-${page}`}
            className="pagination-controls__ellipsis"
          >
            ...
          </span>
        );
      }
      buttons.push(showPage(page));
      lastPage = page;
    }

    return buttons;
  };

  const handleEntriesChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setProductsPerPage(value);
      setCurrentPage(1);
    }
  };

  return (
    <div className="pagination-controls">
      {/* LEFT SECTION: meta */}
      <div className="pagination-controls__section pagination-controls__meta">
        <label htmlFor="entriesPerPage" className="pagination-controls__label">
          Per Page:
        </label>
        <input
          type="number"
          id="entriesPerPage"
          value={productsPerPage}
          onChange={handleEntriesChange}
          min="1"
          className="pagination-controls__input"
        />
      </div>

      {/* CENTER SECTION: page numbers */}
      <div className="pagination-controls__center-wrapper">
        <div className="pagination-controls__section pagination-controls__pages">
          {renderPageNumbers()}
        </div>
      </div>

      {/* RIGHT SECTION: prev/next */}
      <div className="pagination-controls__section pagination-controls__nav-buttons">
        <ProductListButton
          icon="fas fa-chevron-left"
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        />

        <ProductListButton
          icon="fas fa-chevron-right"
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
      </div>
    </div>
  );
};

export default PaginationControls;
